export default __webpack_public_path__ + "static/media/placeholder_store05-jp-mobile.5c26ed41.png";